import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/** Fil d'Ariane visible + données structurées BreadcrumbList (SEO). */
export const Breadcrumbs = ({ items = [], theme = "light" }) => {
  const dark = theme === "dark";
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 text-xs">
      <Link
        to="/"
        className={`inline-flex items-center gap-1.5 transition-colors ${dark ? "text-white/60 hover:text-gold" : "text-muted-foreground hover:text-gold"}`}
      >
        <Home size={13} /> Accueil
      </Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.name} className="inline-flex items-center gap-1.5">
            <ChevronRight size={12} className={dark ? "text-white/30" : "text-muted-foreground/50"} />
            {last || !it.to ? (
              <span className={dark ? "text-gold" : "text-navy font-medium"} aria-current="page">{it.name}</span>
            ) : (
              <Link to={it.to} className={`transition-colors ${dark ? "text-white/60 hover:text-gold" : "text-muted-foreground hover:text-gold"}`}>
                {it.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

/** Construit le JSON-LD BreadcrumbList correspondant. */
export const breadcrumbSchema = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Accueil", item: "https://worktravelexpert.net/" },
    ...items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: it.name,
      ...(it.to ? { item: `https://worktravelexpert.net${it.to}` } : {}),
    })),
  ],
});
